// ----------------------------------------------------------------------------
// Template: Article
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/social-sharing/social-sharing';
import 'snippets/breadcrumbs/breadcrumbs';
import 'snippets/pagination/pagination';


import 'sections/header/header';
import 'sections/footer/footer';

// Styles
import './_article.scss';

